import requests from "../util";

const URL = "order";

const orderApi = {
    create: async (data: {
        cartId: string;
        value: number;
        title: string;
        installments: number;
        payment: { method: string, softDescriptor: string };
        description?: string;
        metadata?: any;
    }) => requests.post(`${URL}`, data),

    findOne: (id: string) =>
        requests.get(`${URL}/${id}`),

    findAll: (params?: Record<string, any>) =>
        requests.get(`${URL}`),

    update: (id: string, data: any) =>
        requests.patch(`${URL}/${id}`, data),

    remove: (id: string) =>
        requests.delete(`${URL}/${id}`),

    syncPayment: (id: string) =>
        requests.patch(`${URL}/${id}/sync-payment`),

    syncUserOrders: () =>
        requests.post(`${URL}/sync-user-orders`),

    getSplits: (id: string) =>
        requests.get(`${URL}/${id}/splits`),
};

export default orderApi;